import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  getFancyOddForEntity,
  getFancy1OddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Teenpatti2() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "teen6";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
      gameName={"Teenpatti - 2.0"}
    >
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-table-left-box">
              <div className="casino-table-header">
                <div className="casino-nation-detail">Player A</div>
                <div className="casino-odds-box back">Back</div>
                <div className="casino-odds-box lay">Lay</div>
              </div>
              <div className="casino-table-body">
                <div className="casino-table-row ">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">Main</div>
                    <p className="casino-nation-book d-none d-md-block w-100">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player A")}
                    </p>
                  </div>
                  {/* <div className="casino-odds-box back suspended-box"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player A", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player A", casinoData, true)}
                    </span>
                  </div>
                  {/* <div className="casino-odds-box lay suspended-box"> */}
                  <div
                    className={`casino-odds-box lay  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player A", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player A", casinoData, false)}
                    </span>
                  </div>
                </div>
                <div className="casino-table-row under-over-row">
                  <div className="uo-box">
                    <div className="casino-nation-detail">
                      <div className="casino-nation-name">Under 21</div>
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "Player A Under 21"
                        )}
                      </p>
                    </div>
                    {/* <div className="casino-odds-box back suspended-box"> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet(
                          "Player A Under 21",
                          casinoData,
                          dispatch,
                          "back"
                        )
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getFancyOddForEntity(
                          "Player A Under 21",
                          casinoData,
                          true
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="uo-box">
                    <div className="casino-nation-detail">
                      <div className="casino-nation-name">Over 22</div>
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "Player A Over 22"
                        )}
                      </p>
                    </div>
                    {/* <div className="casino-odds-box back suspended-box"> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Player A Over 22", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getFancyOddForEntity(
                          "Player A Over 22",
                          casinoData,
                          true
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-table-box-divider" />
            <div className="casino-table-right-box">
              <div className="casino-table-header">
                <div className="casino-nation-detail">Player B</div>
                <div className="casino-odds-box back">Back</div>
                <div className="casino-odds-box lay">Lay</div>
              </div>
              <div className="casino-table-body">
                <div className="casino-table-row">
                  <div className="casino-nation-detail">
                    <div className="casino-nation-name">Main</div>
                    <p className="casino-nation-book d-none d-md-block w-100">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player B")}
                    </p>
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player B", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player B", casinoData, true)}
                    </span>
                  </div>
                  {/* <div className="casino-odds-box lay"> */}
                  <div
                    className={`casino-odds-box lay  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player B", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player B", casinoData, false)}
                    </span>
                  </div>
                </div>
                <div className="casino-table-row under-over-row">
                  <div className="uo-box">
                    <div className="casino-nation-detail">
                      <div className="casino-nation-name">Under 21</div>
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "Player B Under 21"
                        )}
                      </p>
                    </div>

                    {/* <div className="casino-odds-box back suspended-box"> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet(
                          "Player B Under 21",
                          casinoData,
                          dispatch,
                          "back"
                        )
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getFancyOddForEntity(
                          "Player B Under 21",
                          casinoData,
                          true
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="uo-box">
                    <div className="casino-nation-detail">
                      <div className="casino-nation-name">Over 22</div>
                      <p className="casino-nation-book d-none d-md-block w-100">
                        {getCasinoPlExposureByRunner(
                          casinoPlData,
                          "Player B Over 22"
                        )}
                      </p>
                    </div>
                    {/* <div className="casino-odds-box back suspended-box"> */}
                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Player B Over 22", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getFancyOddForEntity(
                          "Player B Over 22",
                          casinoData,
                          true
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="casino-table-full-box teen2other mt-3">
            {/* <div className="casino-odds-box back"> */}
            <div
              className={`casino-odds-box back  ${
                casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""
              }`}
              onClick={() =>
                setBet(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[0]
                    ?.runnerName,
                  casinoData,
                  dispatch,
                  "back"
                )
              }
            >
              <div>
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/icons/spade.png" />
                <div className="casino-nation-book ">
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[0]?.runnerName"
                  )}
                </div>
              </div>

              <div>
                <span className="casino-odds">
                  {" "}
                  {getFancy1OddForEntity(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[0]
                      ?.runnerName,
                    casinoData,
                    true
                  )}
                </span>
              </div>
            </div>

            <div
              className={`casino-odds-box back  ${
                casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""
              }`}
              onClick={() =>
                setBet(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[3]
                    ?.runnerName,
                  casinoData,
                  dispatch,
                  "back"
                )
              }
            >
              <div>
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/icons/heart.png" />
                <div className="casino-nation-book ">
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[3]?.runnerName"
                  )}
                </div>
              </div>
              <div>
                <span className="casino-odds">
                  {" "}
                  {getFancy1OddForEntity(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[3]
                      ?.runnerName,
                    casinoData,
                    true
                  )}
                </span>
              </div>
            </div>

            <div
              className={`casino-odds-box back  ${
                casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""
              }`}
              onClick={() =>
                setBet(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[2]
                    ?.runnerName,
                  casinoData,
                  dispatch,
                  "back"
                )
              }
            >
              <div>
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/icons/club.png" />
                <div className="casino-nation-book ">
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[2]?.runnerName"
                  )}
                </div>
              </div>
              <div>
                <span className="casino-odds">
                  {" "}
                  {getFancy1OddForEntity(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[2]
                      ?.runnerName,
                    casinoData,
                    true
                  )}
                </span>
              </div>
            </div>

            <div
              className={`casino-odds-box back  ${
                casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""
              }`}
              onClick={() =>
                setBet(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[1]
                    ?.runnerName,
                  casinoData,
                  dispatch,
                  "back"
                )
              }
            >
              <div>
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/icons/diamond.png" />
                <div className="casino-nation-book ">
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[1]?.runnerName"
                  )}
                </div>
              </div>
              <div>
                <span className="casino-odds">
                  {getFancy1OddForEntity(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[1]
                      ?.runnerName,
                    casinoData,
                    true
                  )}
                </span>
              </div>
            </div>

            <div
              className={`casino-odds-box back  ${
                casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""
              }`}
              onClick={() =>
                setBet(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[4]
                    ?.runnerName,
                  casinoData,
                  dispatch,
                  "back"
                )
              }
            >
              <div>
                <b>Odd</b>
                <div className="casino-nation-book ">
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[4]?.runnerName"
                  )}
                </div>
              </div>
              <div>
                <span className="casino-odds">
                  {getFancy1OddForEntity(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[4]
                      ?.runnerName,
                    casinoData,
                    true
                  )}
                </span>
              </div>
            </div>

            <div
              className={`casino-odds-box back  ${
                casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""
              }`}
              onClick={() =>
                setBet(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[5]
                    ?.runnerName,
                  casinoData,
                  dispatch,
                  "back"
                )
              }
            >
              <div>
                <b>Even</b>
                <div className="casino-nation-book ">
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[5]?.runnerName"
                  )}
                </div>
              </div>
              <div>
                <span className="casino-odds">
                  {getFancy1OddForEntity(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[5]
                      ?.runnerName,
                    casinoData,
                    true
                  )}
                </span>
              </div>
            </div>
          </div>

          <div className="casino-table-full-box teen2cards mt-3">
            <div className="card-odd-box">
              <span className="casino-odds">
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[6]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[6]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/A.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[6]?.runnerName"
                )}
              </div>
            </div>

            <div className="card-odd-box">
              <span className="casino-odds">
                {" "}
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[7]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[7]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/2.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[7]?.runnerName"
                )}
              </div>
            </div>
            <div className="card-odd-box">
              <span className="casino-odds">
                {" "}
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[8]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[8]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/3.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[8]?.runnerName"
                )}
              </div>
            </div>
            <div className="card-odd-box">
              <span className="casino-odds">
                {" "}
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[9]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[9]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/4.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[9]?.runnerName"
                )}
              </div>
            </div>
            <div className="card-odd-box">
              <span className="casino-odds">
                {" "}
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[10]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[10]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/5.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[10]?.runnerName"
                )}
              </div>
            </div>
            <div className="card-odd-box">
              <span className="casino-odds">
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[11]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[11]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/6.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[11]?.runnerName"
                )}
              </div>
            </div>
            <div className="card-odd-box">
              <span className="casino-odds">
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[12]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[12]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/7.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[12]?.runnerName"
                )}
              </div>
            </div>
            <div className="card-odd-box">
              <span className="casino-odds">
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[13]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[13]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/8.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[13]?.runnerName"
                )}
              </div>
            </div>
            <div className="card-odd-box">
              <span className="casino-odds">
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[14]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[14]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/9.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[14]?.runnerName"
                )}
              </div>
            </div>
            <div className="card-odd-box">
              <span className="casino-odds">
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[15]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[15]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/10.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[15]?.runnerName"
                )}
              </div>
            </div>
            <div className="card-odd-box">
              <span className="casino-odds">
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[16]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[16]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/J.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[16]?.runnerName"
                )}
              </div>
            </div>
            <div className="card-odd-box">
              <span className="casino-odds">
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[17]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[17]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/Q.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[17]?.runnerName"
                )}
              </div>
            </div>
            <div className="card-odd-box">
              <span className="casino-odds">
                {getFancy1OddForEntity(
                  casinoData?.data?.response?.fancy2OddDetailsDTOS?.[18]
                    ?.runnerName,
                  casinoData,
                  true
                )}
              </span>

              <div
                className={`${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.fancy2OddDetailsDTOS?.[18]
                      ?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/K.png" />
              </div>
              <div className="casino-nation-book ">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "casinoData?.data?.response?.fancy2OddDetailsDTOS?.[18]?.runnerName"
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CasinoPage>
  );
}
